import { LmgService } from "../resource";

const PersonModule = {
  namespaced: true,
  state: {
    datas: [],
    datas_nologin: [],
    data: {},
  },
  mutations: {
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    },
    SET_DATAS_NOLOGIN(state, payload) {
      state.datas_nologin = payload;
    },
  },
  actions: {
    getImage({ commit, state }, payload) {
      return LmgService.PersonGetImage(payload);
    },
    createData({ commit, state }, payload) {
      return LmgService.PersonCreate(payload);
    },
    updateData({ commit, state }, payload) {
      return LmgService.PersonUpdate(payload.get("ID"),payload);
    },
    updateCredit({ commit, state }, payload) {
      return LmgService.PersonUpdateCredit(payload.ID,payload);
    },
    async listData({ commit, state },payload) {
      try {
        const data = await LmgService.PersonList(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS", []);
      }
    },
    async listDataNoLogin({ commit, state },payload) {
      try {
        const data = await LmgService.PersonListNoLogin(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS_NOLOGIN", []);
        } else {
          commit("SET_DATAS_NOLOGIN", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS_NOLOGIN", []);
      }
    },
  },
  getters: {
    getData(state) {
      return state.datas;
    },
    getDataWithAll(state) {
      return [{ID:0,Name:"ทั้งหมด",FName : "ทั้งหมด", LName : ""},...state.datas];
    },
    getDataNoLogin(state) {
      return state.datas_nologin;
    },
    getDataUpper(state){
      let upper =  state.datas.filter((i)=> { return i.UpperID == 0 && i.IsActive == 1});

    

      return [{ID:0,FName:"-",LName:""},...upper]
    },
    getDataActive(state){
      return   state.datas.filter((i)=> { return  i.IsActive == 1});

    }
    
  }
};

export default PersonModule;
